import React, {useEffect, useState} from 'react';
import LazyLoad from 'react-lazyload'
import OrgChart from 'src/components/OrgChart/OrgChart/OrgChart';
import useFetch, {CachePolicies} from "use-http";

const TestOrgChart = () => {


    return (
        <OrgChart ></OrgChart>
    );
}

export default TestOrgChart
